const VERSION = '1.3.40';
const GIT_MERGE = '487';
const GIT_CHASH = 'dfaa0cb3d6b042ac6eb2dbfce53c8a15bb26ad9f';

module.exports = {
    VERSION,
    GIT_MERGE,
    GIT_CHASH
}



// WEBPACK FOOTER //
// ./src/constants/version.js